<template>
  <div class="tab config-tab layout-config-tab">
    <span>
      <strong>{{ $t('container') }}</strong>
    </span>

    <br />
    <ColorPicker
      :label="$t('background-color')"
      :color="options.wrapper.backgroundColor"
      @submit="value => propChanged('wrapper.backgroundColor', value)"
    />
    <hr />
    <div>
      <div class="spacement-label">{{ $t('broadcasts-padding') }} (px)</div>
      <div class="placements">
        <div class="placement">
          <span class="text">{{ $t('top') }}</span>
          <SpacementInput
            :value="options.wrapper.paddingTop"
            @change="value => propChanged('wrapper.paddingTop', value)"
          />
        </div>
        <div class="placement">
          <span>{{ $t('bottom') }}</span>
          <SpacementInput
            :value="options.wrapper.paddingBottom"
            @change="value => propChanged('wrapper.paddingBottom', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('left') }}</span>
          <SpacementInput
            :value="options.wrapper.paddingLeft"
            @change="value => propChanged('wrapper.paddingLeft', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('right') }}</span>
          <SpacementInput
            :value="options.wrapper.paddingRight"
            @change="value => propChanged('wrapper.paddingRight', value)"
          />
        </div>
      </div>
    </div>
    <hr />
    <div>
      <div class="spacement-label">{{ $t('broadcasts-margin') }} (px)</div>
      <div class="placements">
        <div class="placement">
          <span class="text">{{ $t('top') }}</span>
          <SpacementInput
            :value="options.wrapper.marginTop"
            @change="value => propChanged('wrapper.marginTop', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('bottom') }}</span>
          <SpacementInput
            :value="options.wrapper.marginBottom"
            @change="value => propChanged('wrapper.marginBottom', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('left') }}</span>
          <SpacementInput
            :value="options.wrapper.marginLeft"
            @change="value => propChanged('wrapper.marginLeft', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('right') }}</span>
          <SpacementInput
            :value="options.wrapper.marginRight"
            @change="value => propChanged('wrapper.marginRight', value)"
          />
        </div>
      </div>
    </div>
    <hr />
    <span
      ><strong>{{ $t('navigation') }}</strong></span
    >
    <br />
    <ColorPicker
      :label="$t('background-color')"
      :color="options.sidenav.backgroundColor"
      @submit="value => propChanged('sidenav.backgroundColor', value)"
    />
    <hr />
    <div>
      <div class="spacement-label">{{ $t('sidenav-padding') }} (px)</div>
      <div class="placements">
        <div class="placement">
          <span class="text">{{ $t('top') }}</span>
          <SpacementInput
            :value="options.sidenav.paddingTop"
            @change="value => propChanged('sidenav.paddingTop', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('bottom') }}</span>
          <SpacementInput
            :value="options.sidenav.paddingBottom"
            @change="value => propChanged('sidenav.paddingBottom', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('left') }}</span>
          <SpacementInput
            :value="options.sidenav.paddingLeft"
            @change="value => propChanged('sidenav.paddingLeft', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('right') }}</span>
          <SpacementInput
            :value="options.sidenav.paddingRight"
            @change="value => propChanged('sidenav.paddingRight', value)"
          />
        </div>
      </div>
    </div>
    <hr />
    <div>
      <div class="spacement-label">{{ $t('sidenav-margin') }} (px)</div>
      <div class="placements">
        <div class="placement">
          <span class="text">{{ $t('top') }}</span>
          <SpacementInput
            :value="options.sidenav.marginTop"
            @change="value => propChanged('sidenav.marginTop', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('bottom') }}</span>
          <SpacementInput
            :value="options.sidenav.marginBottom"
            @change="value => propChanged('sidenav.marginBottom', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('left') }}</span>
          <SpacementInput
            :value="options.sidenav.marginLeft"
            @change="value => propChanged('sidenav.marginLeft', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('right') }}</span>
          <SpacementInput
            class="w-100"
            :value="options.sidenav.marginRight"
            @change="value => propChanged('sidenav.marginRight', value)"
          />
        </div>
      </div>
    </div>
    <hr />
    <span>{{ $t('content') }}:</span>
    <br />
    <div>
      <div class="spacement-label">{{ $t('content-padding') }} (px)</div>
      <div class="placements">
        <div class="placement">
          <span class="text">{{ $t('top') }}</span>
          <SpacementInput
            :value="options.content.paddingTop"
            @change="value => propChanged('content.paddingTop', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('bottom') }}</span>
          <SpacementInput
            :value="options.content.paddingBottom"
            @change="value => propChanged('content.paddingBottom', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('left') }}</span>
          <SpacementInput
            :value="options.content.paddingLeft"
            @change="value => propChanged('content.paddingLeft', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('right') }}</span>
          <SpacementInput
            :value="options.content.paddingRight"
            @change="value => propChanged('content.paddingRight', value)"
          />
        </div>
      </div>
    </div>
    <hr />
    <div>
      <div class="spacement-label">{{ $t('content-margin') }} (px)</div>
      <div class="placements">
        <div class="placement">
          <span class="text">{{ $t('top') }}</span>
          <SpacementInput
            :value="options.content.marginTop"
            @change="value => propChanged('content.marginTop', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('bottom') }}</span>
          <SpacementInput
            :value="options.content.marginBottom"
            @change="value => propChanged('content.marginBottom', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('left') }}</span>
          <SpacementInput
            :value="options.content.marginLeft"
            @change="value => propChanged('content.marginLeft', value)"
          />
        </div>
        <div class="placement">
          <span class="text">{{ $t('right') }}</span>
          <SpacementInput
            :value="options.content.marginRight"
            @change="value => propChanged('content.marginRight', value)"
          />
        </div>
      </div>
    </div>
    <hr />
    <br />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutMixin from '@/components/sidenav/landing/shared/LayoutMixin.js'
import SpacementInput from '../../shared/SpacementInput'

export default {
  name: 'SectionSideNavLayoutTab',
  components: { SpacementInput },
  i18nOptions: { keyPrefix: 'components.sidenav.landing.tabs.layout' },
  mixins: [LayoutMixin],
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      value: '10px',
    }
  },
  methods: {
    ...mapActions('landing', ['updateTabItems']),
  },
}
</script>

<style lang="scss" scoped>
.config-tab {
  padding-bottom: 20px;
  .advanced-collapsible {
    margin: 10px -10px 0;
    padding: 0 !important;
  }
}

/deep/ .dd {
  min-width: auto !important;
}

.layout-config-tab {
  background-color: white;
}

.spacement-label {
  font-weight: bold;
}

.placements {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  .placement {
    margin-top: 8px;
    width: 135px;
    .text {
      text-transform: capitalize;
    }
  }
}
</style>
